// src/components/Modal.js
import { C, FONTS } from '../styles/theme';

export function Modal({ children, onClose }) {
  return (
    <div onClick={e => e.target === e.currentTarget && onClose?.()} style={{
      position: 'fixed', inset: 0, background: 'rgba(61,46,36,0.38)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 200, padding: 24,
    }}>
      <div className="anim-pop-in" style={{
        background: C.white, borderRadius: 28,
        padding: '32px 24px', maxWidth: 340, width: '100%',
        boxShadow: '0 16px 64px rgba(61,46,36,0.18)',
      }}>
        {children}
      </div>
    </div>
  );
}

export function ModalTitle({ children }) {
  return (
    <h2 style={{
      fontFamily: FONTS.display, fontSize: 22,
      color: '#3D2E24', fontStyle: 'italic', marginBottom: 8,
    }}>{children}</h2>
  );
}
